import React from "react";

function Member(props: { user: any, showEdit?: any }) {
  const {user, showEdit} = props;

  function currentScope() {
    if (user.scopes.find((s: string) => s === 'org_user_admin' || s === 'team_user_admin')) {
      return ', Admin';
    } else if (user.scopes.find((s: string) => s === 'org_user_member' || s === 'team_user_member')) {
      return ', Member';
    } else {
      return ', Guest';
    }
  }

  function formatUser() {
    if (user.givenName && user.familyName) {
      return `${user.givenName} ${user.familyName}`;
    } else {
      return user.email;
    }
  }

  return (
    <li className="pb-1">
      {showEdit ?
        <a href="/#" onClick={(e) => {
          showEdit(user.id);
          e.preventDefault();
        }}>{formatUser()}<b>{currentScope()}</b></a>
        : <div>{formatUser()}</div>
      }
    </li>
  );
}

export default Member;
